<!--Image widget-->
<div class="image-content" [style.width]="'100%'" [style.height]="'100%'" [style]="containerStyle" #htmlContent>
  <div *ngIf="!isLoading()" class="content-image">

    <ng-container *ngIf="showTitle && titlePosition == 'top'">
      <div class="block-label">
        @if (richTitle && showTitle) {
        <app-widget-title [title]="title" [design]="widget?.design?.title"></app-widget-title>
        } @else {
        <p [style]="titleStyle" *ngIf="showTitle">{{ title }}</p>
        }
        <span class="error" *ngIf="error">{{ error }}</span>
      </div>
    </ng-container>

    <img *ngIf="image && image.url" [src]="image.url" [class.contain]="imageStyle === 'contains'"
      [class.stretched]="imageStyle === 'stretched'" [class.cover]="imageStyle === 'cover'" (click)="onImgClick()"
      (load)="widgetRendered = true" (error)="widgetRendered = true" />

    <ng-container *ngIf="showTitle && titlePosition != 'top'">
      <div class="block-label">
        @if (richTitle && showTitle) {
        <app-widget-title [title]="title" [design]="widget?.design?.title"></app-widget-title>
        } @else {
        <p [style]="titleStyle" *ngIf="showTitle">{{ title }}</p>
        }
        <span class="error" *ngIf="error">{{ error }}</span>
      </div>
    </ng-container>

  </div>

  <div id="chart-rendered" *ngIf="widgetRendered && !isLoading()"></div>
  <app-widget-loading *ngIf="isLoading()" [graphType]="widget?.graphType"></app-widget-loading>
</div>